import { TRACKING_COOKIE, COOKIE_MAX_AGE_DAYS } from './constants';

function isBrowser() {
  return typeof window !== 'undefined';
}

function getCookieDomain() {
  if (!isBrowser()) return '';
  const { hostname } = window.location;
  if (hostname === 'comparacorsi.it' || hostname.endsWith('.comparacorsi.it')) {
    return '.comparacorsi.it';
  }
  return hostname;
}

function getCookie(name) {
  if (!isBrowser()) return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value) {
  if (!isBrowser()) return;
  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
  const domain = getCookieDomain();
  const domainPart = domain ? `; domain=${domain}` : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/${domainPart}; max-age=${maxAge}; SameSite=Lax`;
}

function generateTrackingId() {
  if (isBrowser() && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

export function getTrackingId() {
  if (!isBrowser()) return '';

  const fromCookie = getCookie(TRACKING_COOKIE);
  if (fromCookie) return fromCookie;

  const fromUrl = new URLSearchParams(window.location.search).get('tracking_id');
  const id = fromUrl || generateTrackingId();
  setCookie(TRACKING_COOKIE, id);
  return id;
}

export function initTrackingId() {
  return getTrackingId();
}
